/**
 * 菜单 权限 树选择
 */
import React from "react";
import CmModal from "../../../../../components/CmModal/CmModal";
import BaseComponent from "../../../../../base/BaseComponent";
import { generateTreeData, treeForEach, filterForEach, treeForEachReverse } from "../../../../../utils";
import CmTree from "../../../../../components/CmTree/CmTree";
import { Icon, Spin } from "antd";


export default class MenuAndPermissionSelect extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            editData: null,
            treeData: [],
            expandedKeys: [],
            autoExpandParent: true,
            checkedKeys: {
                checked: [],
                halfChecked: []
            },
            spinning: false
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.visible && prevProps.visible !== this.props.visible) {
            this.setTreeData();
        }
    }

    componentDidMount() {
        this.setTreeData();
    }

    render() {
        const {
            visible
        } = this.props;
        const {
            treeData,
            expandedKeys,
            checkedKeys,
            autoExpandParent,
            spinning
        } = this.state;
        return (
            <CmModal
                title="绑定菜单"
                visible={visible}
                handleCancel={this.handleCancel}
                handleOk={this.handleOk}
                width={400}
                destroyOnClose={true}
            >
                <div style={{
                    height: "360px"
                }}>
                    <CmTree
                        onExpand={this.onExpand}
                        expandedKeys={expandedKeys}
                        autoExpandParent={autoExpandParent}
                        checkedKeys={checkedKeys}
                        onCheck={this.onCheck}
                        checkable={true}
                        showIcon={true}
                        checkStrictly={true}
                        treeData={treeData}
                        selectable={false}
                    />
                </div>
                {/*滚动条缝隙样式*/}
                <style>
                    {`.cm-scrollbars > div:nth-child(3){
                             margin-bottom: -8px;
                         `}
                </style>
            </CmModal>
        );
    }

    onCheck = (c, e) => {
        let { treeData, checkedKeys: { checked } } = this.state;

        const id = e.node.props.id;
        const check = !checked.includes(id);


        treeForEach(treeData, node => {
            // 找到当前节点
            if (id === node.id) {
                const data = node.data;
                // 如果是权限节点  直接添加删除
                if (data.type === "2") {
                    if (check) {
                        checked.push(id);
                    } else {
                        checked = checked.filter(item => item !== id);
                    }
                } else {
                    // 不是权限节点 是菜单节点
                    // 菜单选中 上级菜单选中
                    // 菜单取消 下级菜单全取消
                    if (check) {
                        const t = filterForEach(treeData, node => node.id === id);
                        //适配父级选中子集
                        let childEach=(list)=>{
                            list.forEach(listNode=>{
                                checked.push(listNode.id);
                                if ((listNode && listNode.data && listNode.data.child && listNode.data.child.length > 0) || (listNode && listNode.child && listNode.child.length > 0)) {
                                    childEach(listNode.data && listNode.data.child || listNode.child)
                                }
                            })
                        }; //适配父级选中子集结束
                        treeForEach(t, node => {
                            //适配父级选中子集
                            if(node.data&&node.data.child&&id === node.id){
                                childEach(node.data.child)
                            }//适配父级选中子集结束
                            checked.push(node.id);
                        });

                    } else {
                        treeForEach([node], nodeItem => {
                            if (nodeItem.data.type !== "2") {
                                checked = checked.filter(item => item !== nodeItem.id);
                            }
                        });
                    }
                }
            }
        });
        checked = checked.filter((item, index) => checked.indexOf(item) === index);
        //  checked=c
        this.setState({
            checkedKeys: { checked, halfChecked: [] }
        });
    };

    onExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false
        });
    };

    handleCancel = () => {
        this.setState({
            checkedKeys: {
                checked: [],
                halfChecked: []
            }
        });
        this.props.handleCancel();
    };

    handleOk = () => {
        const { checkedKeys: { checked }, treeData } = this.state;
        // permissionCodes = ["read_info_permission"]
        const menuCods = [], permissionCodes = [];
        treeForEach(treeData, node => {
            if (checked.includes(node.id)) {
                if (node.data.type === "1") {
                    menuCods.push(node.data.menuCode);
                } else {
                    permissionCodes.push(node.data.code);
                }
            }
        });
        this.setState({
            checkedKeys: {
                checked: [],
                halfChecked: []
            }
        });
        this.props.handleOk({ menuCods, permissionCodes });
    };

    setCheckedKeys = () => {
        const data = this.props.data;
        if (data) {
            const { treeData } = this.state;
            const { menuCods, permissionCodes } = data;
            const codes = [];
            const codesIds = [];
            if (menuCods) {
                codes.push(...menuCods);
            }
            if (permissionCodes) {
                codes.push(...permissionCodes);
            }
            treeForEach(treeData, node => {
                if (codes.includes(node.data.menuCode)) {
                    codesIds.push(node.id);
                }
            });
            this.setState({
                checkedKeys: {
                    checked: codesIds,
                    halfChecked: []
                }
            });
        }
    };
    // 获取树数据
    setTreeData = () => {
        this.setState({
            spinning: true
        });
        const treeDataIndex = {
            id: "id",
            title: "menuName",
            children: "child",
            key: "id"
        };
        this.getMenuAndPermissionTree(res => {
            let treeData = [res];
            const expandedKeys = [];
            treeForEach(treeData, node => {
                if (Array.isArray(node.permissionObjList)) {
                    node.permissionObjList.forEach(item => {
                        item.menuName = item.name;
                        item.icon = <Icon type="control" />;
                        item.menuCode = item.code;
                    });
                    node.child ? node.child.push(...node.permissionObjList) :
                        node.child = node.permissionObjList;
                }
                if (node.type === "2") {
                    node.menuName = node.name
                    node.icon = <Icon type="control" />;
                    node.menuCode = node.code;
                }
                if (node.child && node.child.length) {
                    expandedKeys.push(node.id);
                }
            }, "child");
            this.onExpand(expandedKeys);
            this.setState({
                treeData: generateTreeData(treeData, treeDataIndex),
                spinning: false
            }, () => {
                this.setCheckedKeys();
            });
        });
    };

    // 获取菜单，权限 树
    getMenuAndPermissionTree = callBack => {
        this.request({
            url: "/cm-sites-sys/menuAndPermission/getMenuAndPermissionTree",
            callBack
        });
    };
}
